/* Step 11d-3 · Mars live find 1 (owner, 01-Nov-2026 11:43 KSA) — the selected engagement is PER TAB.
   - This tab's engagement lives in sessionStorage ("af_eng"): every tab has its own, and it survives a reload or a full page load
     in the same tab (a plain link, the new-version reload, a chunk reload).
   - localStorage "af_eng" is only the STARTING value for a new tab (a tab with nothing of its own yet). It is written on each
     choice, so a new tab opens on the engagement chosen last; it never changes a tab that already has its own.
   - Every reader and writer of "af_eng" goes through this module (EngagementContext, lib/api.js, SavedCopyFrame).
   - Browser storage can be blocked (private mode, a sandboxed frame): every access is wrapped, and a blocked store reads "". */
export const ACTIVE_ENGAGEMENT_KEY = "af_eng";

const _get = (store) => {
  try { return (typeof window !== "undefined" && window[store] && window[store].getItem(ACTIVE_ENGAGEMENT_KEY)) || ""; }
  catch { return ""; }
};
const _set = (store, id) => {
  try { if (typeof window !== "undefined" && window[store]) window[store].setItem(ACTIVE_ENGAGEMENT_KEY, id); } catch { /* blocked */ }
};
const _del = (store) => {
  try { if (typeof window !== "undefined" && window[store]) window[store].removeItem(ACTIVE_ENGAGEMENT_KEY); } catch { /* blocked */ }
};

/** This tab's engagement: its own (sessionStorage), else the starting value for a new tab (localStorage), else "". */
export function readActiveEngagement() {
  return _get("sessionStorage") || _get("localStorage");
}

/** This tab's own engagement only ("" when the tab has none yet). */
export function readTabEngagement() {
  return _get("sessionStorage");
}

/** The tab keeps this engagement (sessionStorage) — no other tab is changed. */
export function keepTabEngagement(id) {
  if (id) _set("sessionStorage", id);
}

/** The user chose an engagement in this tab: the tab keeps it, and it becomes the starting value of the next new tab. */
export function chooseEngagement(id) {
  if (!id) return;
  _set("sessionStorage", id);
  _set("localStorage", id);
}

/** This tab's engagement is gone (deleted, another firm's) or the user signed out: the tab forgets it, and so does the starting
 *  value when it names the same engagement (another tab's own choice is left alone). ``all`` also clears the starting value
 *  whatever it holds (signing out). */
export function forgetActiveEngagement({ all = false } = {}) {
  const mine = readActiveEngagement();
  _del("sessionStorage");
  if (all || !_get("localStorage") || _get("localStorage") === mine) _del("localStorage");
}
